import script from "./ReportButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportButtons.vue?vue&type=script&setup=true&lang=js"

import "./ReportButtons.vue?vue&type=style&index=0&id=dc8b9d18&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc8b9d18"]])

export default __exports__